import type { FunctionComponent } from 'react';
import Tile from '@atlaskit/tile';
import { token } from '@atlaskit/tokens';
import {
  getWorkspaceGradient,
  getWorkspaceInitial,
  WORKSPACE_GRADIENT_BACKGROUNDS,
} from './workspaceGradient';

/** Trello's default logo font size, from WorkspaceDefaultLogo.module.less. */
const INITIAL_FONT_SIZE = '20px';

/**
 * Fixed white rather than `color.text.inverse`.
 *
 * Trello uses the inverse token, but that flips with colour mode while these
 * gradients do not: every one of them is dark in both themes, so the inverse
 * token renders near-black text on a dark tile in dark mode.
 */
const INITIAL_COLOR = '#ffffff';

const LetterTile: FunctionComponent<{ name: string }> = ({ name }) => (
  <Tile label="" size="medium" isInset={false}>
    <div
      style={{
        alignItems: 'center',
        background: WORKSPACE_GRADIENT_BACKGROUNDS[getWorkspaceGradient(name)],
        color: INITIAL_COLOR,
        display: 'flex',
        fontSize: INITIAL_FONT_SIZE,
        fontWeight: token('font.weight.bold', '700'),
        height: '100%',
        justifyContent: 'center',
        lineHeight: 1,
        width: '100%',
      }}
    >
      {getWorkspaceInitial(name)}
    </div>
  </Tile>
);

export default LetterTile;
